import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { deleteData, getData, patchData, postData } from "src/utils/axios/serverHelper";

import { MST1110_R01Dto } from "./Dto_MST1110_R01";
import { MST1110_R01Filter } from "./Store_MST1110_R01";

const baseUrl = `${config.apiUrl}/MST1110_R01`;

export const getMST1110_R01List = async (option: string, params: Partial<MST1110_R01Filter>, listLength: number = 0) => {
    const url = `${baseUrl}/${option}`
    return await getData<ResponseDto<MST1110_R01Dto[]>>(url, {
        params: { 
            ...params,
            listLength: listLength ?? 0
        } as MST1110_R01Filter
    });
}

export const getMST1110_R01AllCount = async (params: Partial<MST1110_R01Filter>) => {
    const url = `${baseUrl}/allCount`;
    return await getData<ResponseDto<number>>(url, {
        params: { 
            ...params
        } as MST1110_R01Filter
    });
}

export const postMST1110_R01 = async (data: MST1110_R01Dto[]) => {
    const url = `${baseUrl}`;

    return await postData<MST1110_R01Dto[], ResponseDto<MST1110_R01Dto[]>>(url, data);
}

export const patchMST1110_R01 = async (data: MST1110_R01Dto[]) => {
    const url = `${baseUrl}`;

    return await patchData<MST1110_R01Dto[], ResponseDto<MST1110_R01Dto[]>>(url, data);
}

export const disableMST1110_R01 = async (data: string[]) => {
    const url = `${baseUrl}/disable`;
    return await patchData<string[], ResponseDto<any>>(url, data);
}

export const deleteMST1110_R01 = async (orgCd: string) => {
    const url = `${baseUrl}/${orgCd}`;
    return await deleteData<ResponseDto<any>>(url);
}

export const downloadExcel_MST1110_R01 = async (option: string, params: Partial<MST1110_R01Filter>, listLength: number = 0) => {
    
    const url = `${baseUrl}/excel/${option}`

    return await getData<ResponseDto<string>>(url, {
        params: { 
            ...params,
            listLength: listLength ?? 0 
        } as MST1110_R01Filter
    });
}
export const getPdfBlob_MST1110_R01 = async (option: string, params: Partial<MST1110_R01Filter>, listLength: number = 0, documentCompCd: string): Promise<Blob> => {
	const url = `${baseUrl}/print`;
	const response = await getData<Blob>(url, {
		params: {
			...params,
			listLength: listLength ?? 0,
			documentCompCd: documentCompCd
		} as MST1110_R01Filter,
		responseType: "blob",
	});
	return new Blob([response.data], { type: "application/pdf" });
};